import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../components/button/Button";
import { GiftCard } from "../../../../components/gift-card/GiftCard";
import { Layout } from "../../../../components/layout/Layout";
import { Link } from "../../../../components/link/Link";
import { Section } from "../../../../components/section/Section";
import { useWindowDimensionsContext } from "../../../../components/windowDimensionsProvider/WindowDimensionsProvider";
import { CurrencyCode } from "../../../../graphql/schema";
import { Routes } from "../../../../services/constants";

import styles from "./gift-card-section.module.scss";

interface GiftCardSectionProps {
  currencyCode: keyof typeof CurrencyCode;
  openRedeemModal: () => void;
  isBlack?: boolean;
}

export const GiftCardSection: FC<GiftCardSectionProps> = ({ currencyCode, openRedeemModal, isBlack = false }) => {
  // access translation keys
  const { t } = useTranslation();

  // calculate viewport dimensions
  const { isTabletLandscapeOrBigger } = useWindowDimensionsContext();

  return (
    <Section className={styles.wrap} gutter={50} centerSelf>
      <Layout className={styles.content} wrap="TABLET_PORTRAIT_MAX">
        <GiftCard
          className={styles["gift-card"]}
          width={isTabletLandscapeOrBigger ? 350 : 250}
          value={"125"}
          currencyCode={currencyCode}
          hideSign
          isBlack={isBlack}
        />
        <div className={styles.section}>
          <p
            className={styles.caption}
            dangerouslySetInnerHTML={{
              __html: t(`The best gift for friends & family is the <strong>SF Suite <span>Gift Card</span></strong>`),
            }}
          />
          <div className={styles["button-wrap"]}>
            <Link
              to={isBlack ? Routes.GIFT_CARD : Routes.GIFT_CARD_SCR}
              kind="SOLID"
              shape="RECT"
              borderRadius="SMALL"
              weight="BOLD"
              height="MEDIUM"
              color="ORANGE"
              fontSize={16}
            >
              {t("Purchase card")}
            </Link>
            <Button
              kind="SOLID"
              shape="RECT"
              borderRadius="SMALL"
              weight="BOLD"
              height="MEDIUM"
              color="YELLOW"
              fontSize={16}
              onClick={openRedeemModal}
            >
              {t("Redeem Gift Card")}
            </Button>
          </div>
        </div>
      </Layout>
    </Section>
  );
};
